module.exports = __webpack_public_path__ + "static/media/family_doctor.34557c93.svg";